import React from 'react'
import { Button, Layout } from 'antd/lib/index'
import { Avatar, Breadcrumb, Card, Icon, Row, Select, Tabs } from 'antd'
import BanksApi from '../../../api/Finance/Lenders'
import style from '../../Corporate/style.css'
import CustomTable from '../../../elements/Table/CustomTable'
import useFetchList from '../../../elements/Hooks/useFetchList'
import { Link, withRouter } from 'react-router-dom'
import { get } from 'lodash'
import { streamUrl } from '../../../variables'
import Status from '../../../elements/Status'
import { dateFormat, sessionItemVal, strVal } from '../../../modules/Utils'
import moment from 'moment'
import State from '../../../elements/State'
import useTitle from '../../../elements/Hooks/useTitle'
import InfoText from '../../../elements/InfoText'
import Auth from '../../../modules/Authentication'
import ContractsApi from '../../../api/Finance/LenderContracts'

import StatusCell from '../../../elements/Table/Cells/StatusCell'

const { Content } = Layout
const { TabPane } = Tabs
const api = new BanksApi()
const lenderContractsApi = new ContractsApi()
const auth = new Auth()

const NewLenderButton = withRouter(({ history }) => {
  return (
    <Button
      type="primary"
      icon={'plus'}
      onClick={() => {
        history.replace('/finance/lenders/new')
      }}>
      New
    </Button>
  )
})

const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 100,
    Cell: ({ value, original }) => (
      <a onClick={() => (window.location = `#/finance/lenders/${original._key}/`)}>
        {get(original, 'image') ? (
          <Avatar src={`${streamUrl}files/${original.image}?action=view&access_token=${auth.getAccessToken()}`} />
        ) : (
          <Avatar icon="global" />
        )}
        <span style={{ marginLeft: '10px' }}>{value}</span>
      </a>
    ),
  },
  {
    Header: 'Full Name',
    accessor: 'fn',
  },
  {
    Header: 'Email',
    accessor: 'email.label',
  },
  {
    Header: 'Phone',
    accessor: 'phone.label',
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: StatusCell,
    filterMethod: (filter, row) => {
      const activeArray = ['Active']
      const revisionArray = ['Draft', 'Submitted', 'Resubmitted', 'Revised']
      const nonActiveArray = ['Rejected', 'Closed', 'Cancelled']
      if (filter.value === 'all') {
        return true
      }
      if (filter.value === 'revision') {
        return revisionArray.includes(row[filter.id])
      }
      return filter.value === true ? activeArray.includes(row[filter.id]) : nonActiveArray.includes(row[filter.id])
    },
    Filter: ({ onChange, filter }) => (
      <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
        <Select.Option value="all">All</Select.Option>
        <Select.Option value={true}>Active</Select.Option>
        <Select.Option value="revision">In Progress</Select.Option>
        <Select.Option value={false}>None Active</Select.Option>
      </Select>
    ),
  },
]
const subColumns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 150,

    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/finance/lenders/${strVal(original, 'owner._id').replace('members/', '')}/contracts/${
            original._key
          }/view`,
        }}
        style={{ marginLeft: '10px' }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Lenders',
    accessor: 'lender.fn',
    width: 400,
    style: { alignment: "left", marginLeft:5 },
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/finance/lenders/${strVal(original, 'owner._id').replace('members/', '')}/`,
        }}
        style={{ marginLeft: '10px' }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Company',
    accessor: 'company.fn',
    width: 400,
    style: { alignment: "left", marginLeft:5 }
  },
  {
    Header: 'Type',
    accessor: 'type',
    Cell: ({ value }) => value && (value).toUpperCase(),
  },
  {
    Header: 'Base Currency',
    accessor: 'currency[0]',
    Cell: ({ value }) => value && (value).toUpperCase(),
    hideable: true,
    hideDefault: true
  },
  {
    Header: 'Center',
    accessor: 'center[0].name',
    hideable: true,
    hideDefault: true
  },
  {
    Header: 'Expiry Date',
    accessor: 'date.expiry',
    Cell: ({ value }) => value && dateFormat(moment(value)),
  },
  {
    Header: 'Services State',
    accessor: 'state',
    width: 150,
    Cell: ({ value }) => value && <State value={sessionItemVal('general_state_dropdown', value)} tooltip={false} />,
  },
  /*{
    Header: 'Billing State',
    accessor: 'billingState',
    width: 150,
    Cell: ({value}) =>
      value && (
        <State
          value={sessionItemVal('general_state_dropdown', value)}
          tooltip={false}
        />
      ),
  },*/
  {
    Header: 'Document Status',
    accessor: 'status',
    width: 150,
    Cell: ({ value }) => <Status value={value} tooltip={false} />,
    filterMethod: (filter, row) => {
      const activeArray = ['Active']
      const revisionArray = ['Draft', 'Submitted', 'Resubmitted', 'Revised']
      const nonActiveArray = ['Rejected', 'Closed', 'Cancelled']
      if (filter.value === 'all') {
        return true
      }
      if (filter.value === 'revision') {
        return revisionArray.includes(row[filter.id])
      }
      return filter.value === true ? activeArray.includes(row[filter.id]) : nonActiveArray.includes(row[filter.id])
    },
    Filter: ({ onChange, filter }) => (
      <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : true}>
        <Select.Option value="all">All</Select.Option>
        <Select.Option value={true}>Active</Select.Option>
        <Select.Option value="revision">In Progress</Select.Option>
        <Select.Option value={false}>None Active</Select.Option>
      </Select>
    ),
  },
]

function LendersList(props) {
  const { list, fetching, fetch } = useFetchList(api.list)
  const { list: contracts, fetching: fetchingContracts, fetch: fetchContracts } = useFetchList(lenderContractsApi.list)
  useTitle('Lenders')
  return (
    <Content style={{ margin: '0px 0px' }}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Finance</Breadcrumb.Item>
            <Breadcrumb.Item>Finance Partner List</Breadcrumb.Item>
          </Breadcrumb>
          <h2 className={style.title}>Finance Partners</h2>
          <p className={style.paragraph}>List of all Finance Partners in system. You can filter or create a new Finance Partner.</p>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey={get(props, 'location.hash') || '#users'} onChange={(key) => props.history.push(key)}>
          <TabPane
            tab={
              <span>
                <Icon type="user" />
                Finance Partner Listing
              </span>
            }
            key="#users">
            <CustomTable
              defaultSorted={[
                {
                  id: 'fn',
                  desc: false,
                },
              ]}
              CreateButton={() => <NewLenderButton />}
              isFilterable={true}
              columns={columns}
              data={list}
              fetching={fetching}
              fetch={fetch}
            />
          </TabPane>
          <TabPane
            tab={
              <span>
                <Icon type="book" />
                Partner Accounts
              </span>
            }
            key="#contracts">
            <CustomTable
              isFilterable={true}
              defaultSorted={[
                {
                  id: 'lender.fn',
                  desc: false,
                },
              ]}
              defaultFiltered={[
                {
                  id: 'status',
                  value: true,
                },
              ]}
              columns={subColumns}
              data={contracts}
              fetching={fetchingContracts}
              fetch={fetchContracts}
            />
            <InfoText text={'Click on an account code to view.'} />
          </TabPane>
        </Tabs>
      </Card>
    </Content>
  )
}

LendersList.propTypes = {}
LendersList.defaultProps = {}

export default LendersList
